import { Box, Group, Menu, MenuProps, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useLocation } from "react-router";

import anchor from "../../Anchor.module.css";
import dropdown from "../../Dropdown.module.css";
import { HeaderNavMenuItem } from "../MenuItem";
import { HeaderNavSubmenu } from "../SubMenu";

import { IconChevronDown, IconChevronUp } from "@/components/icons";

import type { MantineSize } from "@mantine/core";
import type { FC } from "react";
import type { NavLinkItem } from "../../types";

export type HeaderNavMenuProps = NavLinkItem &
  Required<Pick<NavLinkItem, "children">> & {
    size?: MantineSize;
  } & Omit<MenuProps, "children">;

export const HeaderNavMenu: FC<HeaderNavMenuProps> = ({ children, label, size, to, ...props }) => {
  const { pathname } = useLocation();
  const [opened, { open, close }] = useDisclosure();
  const isActive = to ? pathname.startsWith(to) : false;
  const textProps = isActive ? { "aria-current": true } : undefined;

  return (
    <Menu classNames={dropdown} opened={opened} onOpen={open} onClose={close} {...props}>
      <Menu.Target>
        <Box component="span" display="inline-block" style={{ cursor: "pointer" }}>
          <Group align="center" gap="sm">
            <Text classNames={anchor} size={size} {...textProps}>
              {label}
            </Text>
            {opened ? (
              <IconChevronUp color="white" size={18} />
            ) : (
              <IconChevronDown color="white" size={18} />
            )}
          </Group>
        </Box>
      </Menu.Target>
      <Menu.Dropdown py="md">
        {children.map((item, index) => {
          if (item.children) {
            return (
              <HeaderNavSubmenu
                key={index}
                children={item.children}
                label={item.label}
                size={size}
                to={item.to}
              />
            );
          }

          return <HeaderNavMenuItem key={index} label={item.label} size={size} to={item.to} link />;
        })}
      </Menu.Dropdown>
    </Menu>
  );
};
